export enum ColumnType {
  TEXT,
  INPUT,
  INPUT_NUMBER,
  CHECKBOX,
  CHECKBOX_EDIT,
  DATE_PICKER,
  SELECT,
  SELECT_EDIT,
  TEXTAREA,
  ARRAY_HIDDEN,
  NUMBER,
  DATE,
  ACTION,
  TAG,
  DATE_TIME_PICKER,
  DATE_TIME_RANGE_PICKER,
  DATE_RANGE_PICKER,
  SELECT_INT,
  INT,
  RECORDING_FILE,
  LINK,
  LINK2,
  HTML,
  SELECT_IN_TD,
  TEXT_CENTER,
  TEXT_LEFT,
  FLAG,
  DOT,
  PROCESS,
  LINK_ARRAY,
  PERCENT,
  RANGE_NUMBER,
  ACTION_MORE,
  BUTTON,
  ICON,
  PERCENT_CENTER,
  SELECT_MULTI,
  SWITCH,
  INPUT_COLOR,
  SWITCH_NOT_ACTION,
  LINK_ARRAY2,
  UPLOAD_FILE,
  IMG_LINK,
  STATUS,
  YEAR_RANGE,
  DATE_RANGE_PICKER_YEAR,
  FILE_NAME,
  PLAYER_LIST_HEADER,
  TODAY,
  WITH_SUB_TITLE,
  DATE_PICKER_SHOW_TIME,
  DATE_PICKER_YEAR,
}
export enum scopeTableEnum {
  COL = 'col',
  ROW = 'row',
  COLGROUP = 'colgroup',
  ROWGROUP = 'rowgroup'
}
export enum OperatorSearch {
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  GREATER = 'GREATER',
  GREATER_EQUAL = 'GREATER_EQUAL',
  LOWER = 'LOWER',
  LOWER_EQUAL = 'LOWER_EQUAL',
  IN = 'IN',
  LIKE = 'LIKE',
  ORDER = 'ORDER',
  BETWEEN = 'BETWEEN',
  LIMIT = 'LIMIT',
  OFFSET = 'OFFSET',
  NOT_IN = 'NOT_IN',
}
export enum TypeFieldSearch {
  STRING = 'string',
  LONG = 'long',
  DATE = 'date', // string format DD/MM/YYYY HH:mm:ss
  BYTE = 'byte',
  INT = 'int',
  BOOLEAN = 'boolean',
}
export enum LogicSearch {
  OR = 'or',
  AND = 'and'
}
export enum SortType {
  DESC = 'desc',
  ASC = 'asc'
}
export enum ActionType {
  CREATE,
  UPDATE,
  DELETE,
  VIEW
}
export enum AddressSelectorTypes {
  country = 'country',
  province = 'province',
  district = 'district',
  commune = 'commune',
  areaStore = 'areaStore',
  provinceStore = 'provinceStore',
  districtStore = 'districtStore',
  communeStore = 'communeStore',
}
